'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLayers = function MapsLayers(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
  );
};
MapsLayers = (0, _pure2.default)(MapsLayers);
MapsLayers.displayName = 'MapsLayers';

exports.default = MapsLayers;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/maps/layers.js
 ** module id = 1712
 ** module chunks = 0
 **/